import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Feedback } from '../shared/models/feedback.model';

@Injectable()
export class FeedbackService {
  private http = inject(HttpClient);


  add(feedback: Feedback): Observable<void> {
    return this.http.post<void>('/api/feedback', feedback);
  }

  getAll(): Observable<Feedback[]> {
    return this.http.get<Feedback[]>('/api/feedbacks');
  }

  update(feedback: Feedback): Observable<any> {
    return this.http.put(`/api/feedback/${feedback._id}`, feedback);
  }

  delete(feedback: Feedback): Observable<any> {
    return this.http.delete(`/api/feedback/${feedback._id}`);
  }

}
